const carouselItems = [
  {
    id: 1,
    title: '2026暑期档 · 最强国剧季',
    desc: '《庆余年2》《长相思》《莲花楼》三大古装巨制同台竞技，这个暑假在被窝网电影一次追个够！',
    tag: '暑期特辑',
    img: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20drama%20collage%20with%20ancient%20palace%20and%20martial%20arts%20elements%2C%20warm%20golden%20sunset%20lighting%2C%20cinematic%20summer%20atmosphere%2C%20artistic%20illustration%20style%2C%20terracotta%20and%20amber%20tones%2C%20dramatic%20composition&width=1200&height=600&seq=carousel-01&orientation=landscape',
  },
  {
    id: 2,
    title: '悬疑剧迷必看 · 烧脑神作合集',
    desc: '《狂飙》《漫长的季节》《隐秘的角落》——国产悬疑剧天花板，剧情反转不断，熬夜刷完停不下来。',
    tag: '悬疑精选',
    img: 'https://readdy.ai/api/search-image?query=Mysterious%20urban%20night%20scene%20with%20dramatic%20shadow%20play%20and%20warm%20streetlamp%20glow%2C%20thriller%20atmosphere%2C%20cinematic%20noir%20style%2C%20artistic%20illustration%2C%20amber%20and%20deep%20shadow%20contrast&width=1200&height=600&seq=carousel-02&orientation=landscape',
  },
  {
    id: 3,
    title: '韩剧控的天堂 · 热门韩剧一网打尽',
    desc: '《黑暗荣耀》《财阀家的小儿子》《非常律师禹英禑》等高分韩剧全集，韩语中字高清在线观看。',
    tag: '韩剧专区',
    img: 'https://readdy.ai/api/search-image?query=Romantic%20Korean%20drama%20atmosphere%20with%20cherry%20blossoms%20and%20warm%20evening%20light%2C%20soft%20cinematic%20aesthetic%2C%20pastel%20warm%20tones%2C%20artistic%20illustration%20style%2C%20emotional%20and%20dreamy%20mood&width=1200&height=600&seq=carousel-03&orientation=landscape',
  },
  {
    id: 4,
    title: '经典永不过时 · 豆瓣高分剧重温',
    desc: '《琅琊榜》《甄嬛传》《武林外传》《父母爱情》——那些年我们追过的经典，被窝网电影高清全集随时重温。',
    tag: '经典重温',
    img: 'https://readdy.ai/api/search-image?query=Nostalgic%20warm%20cinematic%20scene%20with%20soft%20golden%20vintage%20light%2C%20classic%20drama%20atmosphere%2C%20timeless%20elegant%20composition%2C%20artistic%20illustration%20style%2C%20amber%20and%20cream%20tones%2C%20comforting%20mood&width=1200&height=600&seq=carousel-04&orientation=landscape',
  },
];

export default function SectionCarousel() {
  return (
    <section id="carousel" className="py-14 md:py-20 px-4 md:px-6 bg-background-100" style={{ scrollMarginTop: '64px' }}>
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-3">
            焦点专题
          </span>
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-2">焦点专题 · 精选追剧指南</h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">精选四大专题，帮你发现值得追的好剧</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {carouselItems.map((item) => (
            <article key={item.id} className="group relative rounded-2xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer">
              <div className="relative h-56 md:h-64 overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/55 via-black/15 to-transparent"></div>
                <span className="absolute top-4 left-4 px-3 py-1 rounded-full bg-primary-500 text-background-50 text-xs font-medium">
                  {item.tag}
                </span>
              </div>
              <div className="p-5">
                <h3 className="font-heading text-base md:text-lg text-foreground-950 mb-2 group-hover:text-primary-600 transition-colors">{item.title}</h3>
                <p className="text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}